/** @jsxImportSource @emotion/react */
import { memo, useState, useEffect } from "react";

import {
  accordionWrap,
  accordionTitleWrap,
  accordionTitle,
  accordionImg,
  content_open,
  content_close,
} from "assets/css/stylesCss";

import AccordionCheckBox from "../checkbox/AccordionCheckBox";

//アコーディオン -ボタン
import closeSmall from "assets/img/accordion/ico-AccordionClose.png";
import closeMedium from "assets/img/accordion/ico-AccordionClose@2x.png";
import closeLarge from "assets/img/accordion/ico-AccordionClose@3x.png";

//アコーディオン +ボタン
import openSmall from "assets/img/accordion/ico-AccordionOpen.png";
import openMedium from "assets/img/accordion/ico-AccordionOpen@2x.png";
import openLarge from "assets/img/accordion/ico-AccordionOpen@3x.png";

/**
 * 展開、折りたたみするアコーディオン
 * @param {String} title アコーディオンのタイトル
 * @param {Boolean} isOpenState 開閉状態
 * childrenにアコーディングを開いた時の要素群を入れる
 */
const AccordionOnCheckbox = memo(({ title, isChecked, children }) => {

  // アコーディオンが開いているかどうか
  const [isOpen, setIsOpen] = useState(false);

  // 初回ロード時にアコーディオンを開いた状態で表示
  useEffect(() => {
    setIsOpen(isChecked)
  }, []);

  return (
    <div css={accordionWrap}>
      <div
        css={accordionTitleWrap}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <p css={accordionTitle}>{title}</p>
        {/* 開閉アイコン切り替え */}
        {isOpen ? (
          <img
            css={accordionImg}
            src={closeSmall}
            srcSet={`${closeSmall} 1x, ${closeMedium} 2x, ${closeLarge} 3x`}
            alt="開閉アイコン"
          />
        ) : (
          <img
            css={accordionImg}
            src={openSmall}
            srcSet={`${openSmall} 1x, ${openMedium} 2x, ${openLarge} 3x`}
            alt="開閉アイコン"
          />
        )}
      </div>

      {/* アコーディオンを開いた時に表示される */}
      <div css={isOpen ? content_open : content_close}>
        {children.map((item, index) => (
          <AccordionCheckBox
            key={index}
            id={item.props.name + "-" + item.props.value}
            name={item.props.name}
            value={item.props.value}
          >
            {item.props.children}
          </AccordionCheckBox>
        ))}
      </div>
    </div>
  );
});

export default AccordionOnCheckbox;
